<template>
  <div class="search" :class="{'search--active': $root.isSearchOpen}">
    <form action="/en/search" class="search__form" method="POST" @submit.prevent="translate">
      <input type="text" class="search__input" name="search" autocomplete="off" :placeholder="text" @input="getSuggest" @focus="isActive = true" v-model="query" v-click-outside="hide">
      <button type="submit" class="search__btn"><i class="i i-search"></i></button>
      <div class="search__suggests" :class="{'is-active':isActive}">
        <a v-for="(item, index) in suggestList" class="search__suggest" target="_self" :class='{"is-active": currentItem === index}' :key="index" :href="`/${$root.state.lang}/search/?search=${item}`">{{item}}</a>
      </div>

    </form>
  </div>
</template>


<style lang="scss">
.search {
  position: absolute;
  left: 10px;
  top: -1px;
  right: 50px;
  display: none;
  z-index: 50;
  &--active {
    display: flex;
  }
  @include mq('md') {
    position: relative;
    left: 0;
    top: 0;
    right: 0;
    width: 280px;
    display: flex;
  }
  &__form {
    width: 100%;
    display: flex;
    position: relative;
    margin-bottom: 0;
  }
  &__input {
    width: 100%;
    height: 40px;
    background: $color-background;
    border: 0;
    outline: none;
    padding: 0 20px;
    padding-right: 30px;
    color: $color-link-hover;
  }
  &__suggests {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    display: none;
    flex-direction: column;
    background: $color-background-overlay;
    box-shadow: 0px 6px 20px rgba(54, 54, 62, 0.16);
    padding: 10px 14px;
    &.is-active {
      display: flex;
    }
    &:empty {
      display: none;
    }
  }
  &__suggest {
    display: inline-flex;
    text-transform: capitalize;
    &.is-active {
      color: $color-link-hover;
    }
    &:not(:last-child) {
      margin-bottom: 5px;
    }
  }
  &__btn {
    color: $color-link;
    position: absolute;
    right: 9px;
    top: 12px;
    .i {
      font-size: 16px;
    }
    @include mq('md') {
      right: 20px;
      .i {
        font-size: 14px;
      }
    }
    
    &:hover {
      color: $color-link-hover;
    }
  }
}
</style>

<script>
import axios from 'axios'
import ClickOutside from 'vue-click-outside'

export default {
  props: {
    text: String
  },
  data: () => ({
    currentItem: -1,
    isActive: false,
    query: '',
    suggestList: []
  }),
  methods: {
    getSuggest() {
      this.currentItem = -1;
      console.log(999);

      if(this.query.length < 3) {
        this.suggestList = [];
        return;
      };

      let that = this;
      axios.get(`https://${location.host}/app/suggest.php?char=${this.query}`)
      .then(function(response) {
        that.suggestList = response.data;
        document.addEventListener("keyup", that.nextItem);
      });

    },
    translate() {
      const that = this;
      axios.get(`https://${location.host}/app/sTranslate.php?text=${this.query}`, { timeout: 1000 })
      .then((response) => {
        if(response.data == '') {
          location.href = `https://${location.host}/${that.$root.state.lang}/search/?search=${this.query}`;
        } else {
          location.href = `https://${location.host}/${that.$root.state.lang}/search/?search=${response.data[0]}`;
        }
      });
    },
    nextItem () {
    	if (event.keyCode == 38) {
      	this.currentItem--
      } else if (event.keyCode == 40) {
      	this.currentItem++
      } else {
        return;
      }

      switch (true) {
        case this.currentItem > this.suggestList.length:
          this.currentItem = 0;
          break;
        case this.currentItem < 0:
          this.currentItem = this.suggestList.length - 1;
          break;
        case this.currentItem == this.suggestList.length:
          this.currentItem = 0;
          break;
        default:
          break;
      }
      

      this.query = this.suggestList[this.currentItem];

    },
    hide() {
      this.isActive = false;
    }
  },
  directives: {
    ClickOutside
  }

}
</script>
